import axios from 'axios';
import {useEffect, useState} from 'react';

import {config, FrontendRoutes} from '../constants';
import {getCurrentUser, isPrivateRoute} from "../pages/root/helpers";
import {useLocation, useHistory} from "react-router-dom";

export const UserData = {
    CustID: '',
    FirstName: 'First Name',
    LastName: '',
    Email: '',
    Company: '',
}

export const useAuth = () => {
    const [data, setData] = useState({user: null});
    const [isError, setIsError] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const history = useHistory()
    const location = useLocation()
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    useEffect(() => {
        const fetchAuth = async () => {
            setIsError(false);
            setIsLoading(true);
            if (token) {
                localStorage.setItem('token', token)
            }
            const authToken = token ? token : localStorage.getItem('token')

            try {
                if(authToken) {
                    const {data} = await axios.get(`${config.API_URL}validateAuthToken`, {
                        headers: {'x-api-key': config["x-api-key"]},
                        params: {token: authToken}
                    });
                    if (data && data.data) {
                        setIsAuthenticated(true)
                        // if (token)
                        // history.push(FrontendRoutes.HOME)

                        setData({user: data.data.length ? data.data[0] : null});
                        localStorage.setItem('user', JSON.stringify(data.data[0]))
                    } else {
                        setIsError(true);
                        localStorage.removeItem('user')
                    }
                } else {
                    setIsError(true);
                    localStorage.removeItem('user')
                }
            } catch (e) {
                console.error(e)
                setIsError(true);
                localStorage.removeItem('user')
            } finally {
                setIsLoading(false);
            }
        };


        fetchAuth();
    }, []);


    return {data, isAuthenticated, isError, isLoading};
};